// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__SYEzB","pos":"Placeholder_pos__ZMrwS","logo":"Placeholder_logo__A_i1R","desc":"Placeholder_desc__1Q1rz"};